import { render, staticRenderFns } from "./confirmarPresupuesto.vue?vue&type=template&id=2297d040&scoped=true"
import script from "./confirmarPresupuesto.vue?vue&type=script&lang=js"
export * from "./confirmarPresupuesto.vue?vue&type=script&lang=js"
import style0 from "./confirmarPresupuesto.vue?vue&type=style&index=0&id=2297d040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2297d040",
  null
  
)

export default component.exports